import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    weight = 1.0,
    oScoreWeight = 1.0,
    details = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projAppraise.saveWeights, {
        id,
        weight,
        oScoreWeight,
        details,
    }, options);
    if (error) return { error, status };
    return content || { info: {}, rows: [] };
};
